// https://xpressdocs.atlassian.net/browse/PROJ-29959
// module.exports = null;
module.exports = {
    user_prog_prefs:{
        "createdAt": "2023-08-17 09:33:20.204435-05",
        "updatedAt": "2023-08-17 09:33:03.969041-05",
        "idAgent": "590a03edb4",
        "idBranch": "32517238",
        "idCompany": "d2dbadb1",
        "idProgram": "1233",
        "auto_resubscribe": false,
        "enrolled": true,
        // "enrolled": false,
        // unenroll_reason: "aaa",
        // unenroll_time: 123,
        "editionsPreferences": [
            {
                "editionId": "e1",
                "comment": "I hope you enjoy Jan",
                "templateId": "402193",
            },
            // {
            //     "editionId": "e4",
            //     "comment": "I hope you enjoy Jan",
            //     "templateId": "402193", // no body cares
            // },
            // {
            //     "editionId": "e2",
            //     "comment": "I hope you enjoy Jan",
            //     "templateId": "402193",
            // },
        ],
        seriesPreferences: [
            {
                id: "2025", // Discrepancy! "seriesId" in doc
                auto_enroll: true,
                // auto_enroll: false,
                auto_renew: true,
                // qrCode: {
                //     "redirectType": "url",
                //     "redirectUrl": "https://aa.vv"
                // },

                // "productOptions": {
                //     // products: [
                //     //     {
                //     //         "productType": "postcards",
                //     //         "paperType": "1", // "default" | "1" ... (id in template_options)
                //     //         // "coating": "high_gloss_coating", // "none" | "default" | (dev_key in template_options)
                //     //         "coating": "matte_touch_coating",
                //     //         "coatingSides": "both", // "side1" | "side2" | "both"
                //     //     },
                //     // ],
                //
                //     // "mailingSeals": true, // true | false | "default"
                //     // "pdfDownload": false, // true | false | "default"
                //     // "envelopes": false, // true | false | "default"
                // },

                // "postcards": {
                //     paperType: "1", // "default" | "1" ... (id in template_options)
                //     // "coating": "high_gloss_coating", // "none" | "default" | (dev_key in template_options)
                //     "coating": "matte_touch_coating",
                //     "sides": "both", // "side1" | "side2" | "both"
                // },
                // "flyers": {
                //     paperType: "default",
                //     "coating": "default",
                //     "sides": "side1",
                // },
            },
        ],
        "profile": {

            // "defaultHeadshot" : "https://picsum.photos/seed/535de/300/200",
            // "defaultHeadshot2" : "https://picsum.photos/seed/535de/300/200",
            // "defaultHeadshot2": "https://picsum.photos/seed/32534/300/200",

            "logoImage": "https://picsum.photos/seed/k2ws1/200/300",
            // "logoImage2": "",

            // defaultTeamHeadshot: "", // Not used by UI
            "agentDisplay1": "John Agent",
            "agentDisplay2": "Licensed RE Salesperon",
            "agentDisplay3": "apm2@xpressdocs.com",
            "agentDisplay4": "m. 866.977.3621",
            "agentDisplay5": "d. 123.456.7899",
            "agentDisplay6": "f. 852.369.5632",
            "agentDisplay7": "johnagent.com",
            "agentDisplay8": "facebook.com/jagent",


            returnAddress: { // Discrepancy! "return_address" in doc
                // address1: "xxx",
                // address2: "xxx",
                // address3: "xxx",
                // address4: "xxx",
                // address5: "xxx",
                // address6: "xxx",
            },

            "informedDelivery": {
                // "redirectType": "homevalue",
                // "redirectType": "xpresslinks",
                "redirectType": "",
                "redirectUrl": "",
                // "representativeImage": "https://picsum.photos/seed/54r27/300/200",
                "enabled": false,
                "displayName": "",
                // "rideAlongImage": "https://picsum.photos/seed/358d/300/200",
                "rideAlongImage": "",
            },
        },
        "distribution_options": {
            "mailing": {
                "enabled": true,
                // "enabled": false,
                "service_level": "3",
                // "mailing_list_xd": ["6401892", "6416582"],
                "mailing_list_xd": [
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5",
                ],
                "unaddressed_copies": {
                    "enabled": true,
                    // "service_level": "FEDEX_GROUND",
                    "quantity": 25,
                    // "addressId": "addressId",
                    "bulk_mail_permit": true
                },
                "sample_card": true
            },
            "shipping": {
                // "enabled": true,
                "enabled": false,
                // "addressId": "addressId",
                // "service_level": "FEDEX_GROUND",
                "quantity": 25,
                "addressed_copies": {
                    "enabled": true,
                    // "enabled": false,
                    // "mailing_list_xd": ["6401892", "6416582"],
                    "bulk_mail_permit": true,
                    "mailer_id": true, //"? seems like there's an api call to get this (GET /next-api/mailer/getMailerId)",
                    "mailer_id_class": 3 //if mailer id is set to be printed and user has it.
                }
            }
        },
        "payment_options": {
            "creditCard": {
                "token": "7zh27f",
                "use_default": false
            },
            // "copay": true,
            "voucher": true,
            // "adbudget": true,
            // "storecredit": true,
            "billingAccount": [
                // {
                //     "id": "24f2e40c",
                //     "amount": "50%", // or "100.00",
                //     "meta1": "value1"
                // },
                // {
                //     "id": "3f10a4fa",
                //     "amount": "50%" // or "100.00",
                // }
            ]
        },
    },
};

// module.exports = null;

// module.exports = {
//     "createdAt": "2023-08-17 09:33:20.204435-05",
//     "updatedAt": "2023-08-17 09:33:03.969041-05",
//     "idAgent": "590a03edb4",
//     "idBranch": "32517238",
//     "idCompany": "d2dbadb1",
//     "idProgram": "1233",
//     enrolled: true,
//     "editionsPreferences": [
//         {
//             "editionId": "54c43f30-4d94-11ee-ba92-2b9f4ec9fbd0",
//             "comment": "I hope you enjoy Jan",
//             "templateId": "402193", // no body cares
//         },
//         // {
//         //     "id": "123",
//         //     "customInfo": {
//         //         "comment": "I hope you enjoy Jan"
//         //     },
//         //     "templateId": "402193"
//         // },
//         // {
//         //     "id": "124",
//         //     "customInfo": {
//         //         "comment": "I hope you enjoy Feb"
//         //     },
//         //     "templateId": "402193"
//         // }
//     ],
//     // "auto_resubscribe": false,
//     "profile": {
//         // "defaultHeadshot": "https://assets-stagetre.xpressdocs.com/pictures/headshot/2021/05/25/3/26410437o.jpg",
//         // "defaultHeadshot2": "https://assets-stagetre.xpressdocs.com/pictures/headshot/2023/08/17/3/31560686o.png",
//         "agentDisplay1": "John Agent",
//         "agentDisplay2": "Licensed RE Salesperon",
//         "agentDisplay3": "apm2@xpressdocs.com",
//         "agentDisplay4": "m. 866.977.3621",
//         "agentDisplay5": "d. 123.456.7899",
//         "agentDisplay6": "f. 852.369.5632",
//         "agentDisplay7": "johnagent.com",
//         "agentDisplay8": "facebook.com/jagent"
//     },
//     "return_address": {
//         "zip": "55391",
//         "city": "WAYZATA",
//         "name": "JOHN SMITH",
//         "state": "MN",
//         "streetAddress": "125 LAKE ST W"
//     },
//     "distribution_options": {
//         "mailing": {
//             "enabled": true,
//             "service_level": "3",
//             "mailing_list_xd": ["6401892", "6416582"],
//             "unaddressed_copies": {
//                 "ship": true,
//                 "quantity": 25,
//                 "addressId": "addressId",
//                 "bulk_mail_permit": true
//             }
//         },
//         "shipping": {
//             "folded": true,
//             "address": {
//                 "zip": "55391",
//                 "city": "WAYZATA",
//                 "name": "JOHN SMITH",
//                 "state": "MN",
//                 "streetAddress": "125 LAKE ST W"
//             },
//             "enabled": true,
//             "quantity": 25,
//             "mailer_id": "? seems like there's an api call to get this (GET /next-api/mailer/getMailerId)",
//             "service_level": "???"
//         }
//     },
//     "payment_options": {
//         "copay": [
//             {
//                 "id": "copay id"
//             }
//         ],
//         "voucher": [
//             {
//                 "id": "06cb77d8de"
//             }
//         ],
//         "adbudget": [
//             {
//                 "id": "b98d165f",
//                 "maxPercentToUse": 20,
//                 "comments": "ad budget comments"
//             }
//         ],
//         "creditCard": {
//             "token": "",
//             "use_default": true
//         },
//         "storecredit": [
//             {
//                 "id": "8aaab2b502067f74abefa6d35a684c08"
//             }
//         ],
//         "billingAccount": [
//             {
//                 "id": "24f2e40c"
//             },
//             {
//                 "id": "3f10a4fa"
//             }
//         ]
//     }
// };